export default "__VITE_ASSET__d819ea65__"